import styled from 'styled-components'
import { TypeFiesta } from '@at/design-system-foundation'

export const PostcodeErrorBannerWrapperModal = styled(TypeFiesta).attrs({ as: 'div' })`
    background-color: ${({ theme }) => theme.color.bgSurface.critical};
    border: 1px solid ${({ theme }) => theme.color.border.critical};
    border-radius: 4px;
    padding: 24px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0 auto 20px auto;
    text-align: center;
    gap: 32px;
    width: 100%;
    max-width: 596px;
`

export const PostcodeErrorBannerWrapper = styled(TypeFiesta).attrs({ as: 'div' })`
    padding: 24px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0 auto 20px auto;
    text-align: center;
    gap: 32px;
    width: 100%;
    max-width: 596px;
`

export const TPFLocationCheckboxContainer = styled.div`
    display: flex;
    justify-content: center;
`
